'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);

// Reference: https://github.com/mui-org/material-ui/blob/27471b4564eb40ff769352d73a29938d25804e45/packages/material-ui/src/utils/getScrollbarSize.js
var getScrollbarSize = function getScrollbarSize() {
  var scrollDiv = document.createElement('div');
  scrollDiv.style.width = '99px';
  scrollDiv.style.height = '99px';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarSize;
};
var useScrollbarWidthOffset = function useScrollbarWidthOffset() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
  React.useLayoutEffect(function () {
    var _window$getComputedSt = window.getComputedStyle(container),
      paddingRight = _window$getComputedSt.paddingRight;
    var scrollbarSize = getScrollbarSize();
    var paddingRightInteger = parseInt(paddingRight, 10);
    container.style.paddingRight = "".concat(paddingRightInteger + scrollbarSize, "px");
    return function () {
      container.style.paddingRight = paddingRight;
    };
  }, [container]);
};

exports.getScrollbarSize = getScrollbarSize;
exports.useScrollbarWidthOffset = useScrollbarWidthOffset;
